export function initAccordions() {
  document.querySelectorAll('.po-accordion__title-area').forEach((title) => {
    title.addEventListener('click', function () {
      const item = this.closest('.po-accordion__item');
      const isOpen = item.classList.contains('po-accordion__item_visible');

      document.querySelectorAll('.po-accordion__item').forEach((el) => {
        el.classList.remove('po-accordion__item_visible');
      });

      if (!isOpen) {
        item.classList.add('po-accordion__item_visible');
      }
    });
  });
}
